<template>
  <b-container>
    <b-row>
      <b-col class="form-area">
        <div class="px-3 py-3 h-100 d-flex flex-column">
          <div class="pb-1">
            <span class="title">
              <i
                class="icon-block mr-2"
                aria-hidden="true"
              />
              {{ $tc('global.block', 1) }}
              {{ entitySelected.label }}
            </span>
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>{{ $t('diagnosis.modals.blockReviewType') }}</label>
            </div>
            <vt-combo-select
              ref="entityRevisionTypesCombo"
              v-model="selectedReviewType"
              v-validate="'required'"
              qa="diagnosis-portionReviewType"
              :class="{ requiredform: (showErrors && !selectedReviewType) }"
              :options="selectedEntityRevisionTypes"
              :allow-empty="false"
              label="translatedName"
            />
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>{{ $t('diagnosis.modals.reviewResponsible') }}</label>
            </div>
            <vt-combo-select
              ref="responsiblePersonnelCombo"
              v-model="selectedResponsiblePersonnel"
              qa="diagnosis-portionReviewResponsible"
              :option-loader="getPersonnel"
              label="fullName"
              track-by="id"
            />
          </div>
          <div class="my-2 d-flex flex-column h-100">
            <div class="form-label">
              <label>{{ $t('global.observations') }}</label>
            </div>
            <b-form-textarea
              v-model="observations"
              class="flex-grow-1"
              qa="diagnosis-portionReviewObservations"
              no-resize
            />
          </div>
        </div>
      </b-col>
      <b-col class="thumbs-area">
        <div>
          <p class="description">
            {{ $t('diagnosis.modals.picturesHelpText') }}
          </p>
        </div>
        <div class="scroll-area">
          <vt-thumbnail
            v-for="(attachment) in attachments"
            :key="attachment.attachmentId"
            ref="attachmentThumbnail"
            :laboratory-id="loggedLaboratoryId"
            :case-id="caseId"
            :sample-id="sampleId"
            :portion-id="entitySelected.id"
            :attachment="attachment"
            @attachmentChecked="getAttachmentsChecked"
            @attachmentSelected="openUrl($event)"
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VtThumbnail from '@/components/common/VtThumbnail'
import { personnelService } from '@/api/resources/personnelService'
import revisionTypeServices from '@/api/resources/common/revisionTypeServices'
import { REVISION_ENTITY_TYPE } from '@/modules/diagnosisModule/constants/revisionEntityType'
import ReviewMixin from '@/modules/diagnosisModule/views/form/modals/reviewModal/mixins/ReviewMixin'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'
const subportionAttachmentService = () => import('@/api/resources/attachment/subportionAttachmentService')
const DiagnosisPortionService = () => import('@/modules/diagnosisModule/services/DiagnosisPortionService')

export default {
    name: 'PortionReview',
    components: { VtThumbnail },
    mixins: [ ReviewMixin ],
    props: {
        entitySelected: { type: Object, default: () => { return {} } },
        loggedLaboratoryId: { type: Number },
        entityCurrentLaboratoryId: { type: Number },
        caseId: { type: Number },
        sampleId: { type: Number },
        sampleGrossingResponsible: { type: Object }
    },
    data() {
        return {
            selectedEntityAttachments: [],
            selectedEntityRevisionTypes: [],
            selectedRevisionAttachments: [],
            selectedReviewType: null,
            selectedResponsiblePersonnel: this.sampleGrossingResponsible,
            showErrors: false,
            attachments: [],
            observations: ''
        }
    },
    computed: {
        ENTITY_TYPE_SUBPORTION() {
            return REVISION_ENTITY_TYPE.SUBPORTION
        },
        request() {
            return {
                observations: this.observations,
                revisionAttachments: this.selectedRevisionAttachments.map(attachmentComponent => {
                    return {
                        attachmentEntityType: attachmentComponent.attachment.attachmentEntityType,
                        attachmentId: attachmentComponent.attachment.attachmentId
                    }
                }),
                revisionResponsibleId: this.selectedResponsiblePersonnel ? this.selectedResponsiblePersonnel.id : null,
                type: this.selectedReviewType.code
            }
        }
    },
    mounted() {
        this.initializeCalls()
    },
    methods: {
        cleanData() {
            this.$_cleanComponentData()
            this.$refs.entityRevisionTypesCombo.clearInternalOptions()
            this.$refs.responsiblePersonnelCombo.clearInternalOptions()
        },
        getAttachmentsChecked() {
            this.selectedRevisionAttachments = this.$refs.attachmentThumbnail ? this.$refs.attachmentThumbnail.filter(thumbnail => thumbnail.isSelected) : []
        },
        async initializeCalls() {
            let attachmentCallPromises = []
            await DiagnosisPortionService().then(service => {
                this.createRevisionCall = service.default
            })
            await subportionAttachmentService().then(service => {
                this.entitySelected.subportions.forEach(subportion => {
                    attachmentCallPromises.push({
                        call: service.default.getAttachments(
                            this.loggedLaboratoryId,
                            this.caseId,
                            this.sampleId,
                            this.entitySelected.id,
                            subportion.id),
                        entityType: this.ENTITY_TYPE_SUBPORTION
                    })
                })
            })
            this.selectedEntityRevisionTypes = await revisionTypeServices.getAllPortionRevisionTypes()
            this.attachments = await this.getAttachments(attachmentCallPromises)
        },
        async getPersonnel() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.entityCurrentLaboratoryId, CommonResponsibilityCodeEnum.EMBEDDING)
        }
    }
}
</script>

<style scoped>

</style>
